<template>
  <!--START GET STARTED-->
  <section class="section section-lg bg-get-start">
    <div class="bg-overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 text-center">
          <h1 class="get-started-title text-white">Partiu Inovação!</h1>
          <div class="section-title-border margin-t-20 bg-white"></div>
          <p
            class="section-subtitle font-secondary text-white text-center padding-t-30"
          >
            Inicie gratuitamente para receber instruções do Startinho, nosso bot
            que vai acompanhá-lo durante o período de teste ajudando-o(a) na
            ingrata tarefa de tirar as coisas do papel!
          </p>
          <a href="#" class="btn btn-bg-white waves-effect margin-t-20 mb-4"
            >Partir<i class="mdi mdi-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="bg-pattern-effect">
      <img src="images/bg-pattern-light.png" alt="" />
    </div>
  </section>
  <!--END GET STARTED-->
</template>

<script>
export default {
  name: "GetStarted",
  props: {}
};
</script>
